/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Number/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Number({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/Content/Form/Number",
  isInvalid,
  onChange
  
}) {
let newPhonePhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'new_phone',
path: 'phone.number',
format: fromFormat.phoneNumberUS,
})
let newPhonePhoneNumberIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_phone',
path: 'phone.number',
validate: fromValidate.phoneNumber,
required: true,
})
let newPhonePhoneNumberChangeData = fromData.useDataChange({ viewPath,
context: 'new_phone',
path: 'phone.number',
formatOut: fromFormat.addPrefixIfMissing,
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 autoFocus={true}
 data="new_phone.phone.number"
 format="/Data/format.js phoneNumberUS"
 formatOut="/Data/format.js addPrefixIfMissing"
 validate="/Data/validate.js phoneNumber"
 invalid={!newPhonePhoneNumberIsValidData}
 required={true}
 value={newPhonePhoneNumberValueData}
 onChange={newPhonePhoneNumberChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Number"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="phone"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}